export const millionnaireCircleContractAddress = "0x997078180438aAfBb8Fc7b39F9ca10AfFFDc2a15";
export const mcgpTokenAddress = "0x517600323e5E2938207fA2e2e915B9D80e5B2b21";
export const payerContractAddress = "0x1d7F46a720aBD1941d220F0939755B22BbE00dd8";
export const usdcTokenAddress = '0x04068DA6C83AFCFA0e13ba15A6696662335D5B75';

// OTC Marketplace (Sonic Mainnet)
export const otcMarketplaceAddress = "0xfEF5d571D47d21A9cd9c6aF423116557Bbb5BF8b";
export const sonicUsdcTokenAddress = "0x29219dd400f2Bf60E5a23d13Be72B486D4038894";

// Sonic Network Config
export const SONIC_CHAIN_ID = 146;
export const SONIC_RPC_URL = "https://rpc.soniclabs.com";
export const SONIC_CHAIN_CONFIG = {
    chainId: `0x${SONIC_CHAIN_ID.toString(16)}`,
    chainName: "Sonic Mainnet",
    nativeCurrency: {
        name: "Sonic",
        symbol: "S",
        decimals: 18,
    },
    rpcUrls: [SONIC_RPC_URL],
    blockExplorerUrls: ["https://sonicscan.org"],
};
